import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { QuillViewHTMLComponent } from 'ngx-quill';
import { Observable } from 'rxjs';
import { ModalComponent } from '@ajgre/toolkit';
import { DashboardState, selectDashboardExecutiveSummary } from '@cmi/store/dashboard';

@Component({
  selector: 'app-dashboard-executive-summary-modal',
  imports: [CommonModule, ModalComponent, QuillViewHTMLComponent],
  templateUrl: './dashboard-executive-summary-modal.component.html',
  styleUrl: './dashboard-executive-summary-modal.component.scss'
})
export class DashboardExecutiveSummaryModalComponent implements OnInit {
  private store = inject<Store<DashboardState>>(Store);

  selectExecutiveSummary$!: Observable<string>;

  ngOnInit() {
    this.selectExecutiveSummary$ = this.store.select(selectDashboardExecutiveSummary);
  }
}
